<template>
    <div class="date_table_tree" style="display: flex">
        <div class="date_table_tree_border">
            <el-tree v-if="treeData.length" ref="tree" :data="treeData" :props="defaultProps" :default-expanded-keys="defaultExpandedKeys" highlight-current node-key="id" @node-contextmenu="openTreeMenu" @node-click="handleNodeClick">
                <span slot-scope="{ node, data }" class="custom-tree-node">
                    <span style="font-size: 12px; width: 160px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{ data.name }}</span>
                </span>
            </el-tree>
            <div v-else class="empty-tree">暂无数据</div>
        </div>
        <div v-show="showTreeMenu" class="treeMenu">
            <div v-if="currentData.id === 'sys'" @click="addMenu(currentData)">
                <i class="el-icon-plus" style="color: #1e9fff"></i>
                增加子分组
            </div>
            <div v-if="currentData.id !== 'sys'" @click="editMenu(currentData)">
                <i class="el-icon-edit" style="color: #fcc465"></i>
                修改分组名称
            </div>
            <div v-if="currentData.id !== 'sys'" @click="delMenu(currentData)">
                <i class="el-icon-delete" style="color: red"></i>
                删除分组
            </div>
        </div>
        <data-table v-if="dataTableShow" ref="dataTable" style="flex: 1" :module-info="moduleInfo" :tb-columns="tbColumns" :toolbar-btns="toolbarBtns" :on-cell-click="cellClick" :on-selected-rows-change="selectedRowsChange" :on-list-data-before-load="onListDataBeforeLoad" :on-list-data-loaded="onListDataLoaded" :on-delete-successed="onDeleteSuccessed">
            <template slot="toolbarLeft-slotLeft">
                <slot name="toolbarLeft-slotLeft" />
            </template>
        </data-table>

        <el-dialog class="dialogStyle" title="证照管理" :visible.sync="dialogVisible" width="40%">
            <el-form :model="rowVO" @submit.native.prevent>
                <div style="width: 100%" class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td ref="tdlbl_证件类型" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'name'" class="field">证件类型</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <form-item
                                            ref="name"
                                            :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入证件类型', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '证件类型', propName: 'name', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'rowVO.name', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                            :vo="rowVO"
                                            :can-edit="canEdit"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td ref="tdlbl_排序序号" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span v-field-lbl="'orderNo'" class="field">排序序号</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <form-item
                                            ref="orderNo"
                                            :field="{
                                                defaultValue: null,
                                                elementCanEdit: '{${canEdit}}',
                                                elementCssHeight: null,
                                                elementCssWidth: null,
                                                elementFormatter: null,
                                                elementReadonly: 0,
                                                elementType: 'input',
                                                emptyMessage: '请输入排序序号',
                                                errorMessage: null,
                                                formTdAlign: 'text-left',
                                                formTdColspan: 0,
                                                isRequired: 0,
                                                onClickEvent: null,
                                                passenger: {},
                                                propComment: '排序序号',
                                                propName: 'orderNo',
                                                propType: 'String',
                                                textFormatter: 'number',
                                                valueMaxLength: '4',
                                                valueMinLength: '4',
                                                model: 'rowVO.orderNo',
                                                option: [],
                                                autocomplete: 'off',
                                                dialog: 0,
                                                showWordLimit: false
                                            }"
                                            :vo="rowVO"
                                            :can-edit="canEdit"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td ref="tdlbl_状态" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'status'" class="field">状态</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <form-item
                                            ref="status"
                                            :field="{
                                                defaultValue: null,
                                                elementCanEdit: '{${canEdit}}',
                                                elementCssHeight: null,
                                                elementCssWidth: null,
                                                elementFormatter: '1：启用\n2：禁用',
                                                elementReadonly: 1,
                                                elementType: 'radio',
                                                emptyMessage: '请选择状态',
                                                errorMessage: null,
                                                formTdAlign: 'text-left',
                                                formTdColspan: 0,
                                                isRequired: 1,
                                                onClickEvent: null,
                                                passenger: {},
                                                propComment: '状态',
                                                propName: 'status',
                                                propType: 'Short',
                                                textFormatter: null,
                                                valueMaxLength: null,
                                                valueMinLength: null,
                                                model: 'rowVO.status',
                                                option: [
                                                    { value: '1', name: '启用' },
                                                    { value: '2', name: '禁用' }
                                                ],
                                                optionGenerateType: 0,
                                                clearable: false,
                                                filterable: false,
                                                allowCreate: false
                                            }"
                                            :vo="rowVO"
                                            :can-edit="canEdit"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="formSubmit">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        moduleInfo: {
            type: Object,
            default: () => ({})
        },
        tbColumns: {
            type: Array,
            default: () => []
        },
        toolbarBtns: {
            type: Array,
            default: () => []
        },
        onListDataBeforeLoad: {
            type: Function,
            default: () => null
        },
        onListDataLoaded: {
            type: Function,
            default: () => null
        },
        onDeleteSuccessed: {
            type: Function,
            default: () => null
        },
        // 默认树节点
        treeRoot: {
            type: [Boolean, String],
            default: () => false
        },
        // 树结构url
        querydataUrl: {
            type: String,
            default: () => ''
        },
        activeTreeNode: {
            type: Object,
            default: () => ({})
        },
        noContextMenu: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            array: [],
            // 当前登陆人
            loginUser: this.$store.getters.loginUser,
            // 默认树节点
            treeRootList: [],
            // 选中节点
            activeNode: null,
            // 列表是否展示
            dataTableShow: true,
            /**
             *
             */
            tree: null,
            treeNode: null,
            treeData: [],
            // 支部数
            zbNum: 0,
            // 总支数
            zzNum: 0,
            productCode: '',
            defaultProps: {
                children: 'children',
                name: 'name'
            },
            data: [],
            showTreeMenu: false,
            currentData: {},
            currentDataid: '',
            defaultExpandedKeys: [], // 默认展开第一个节点
            dialogVisible: false,
            rowVO: {}
        }
    },
    computed: {},
    watch: {
        treeRoot: {
            immediate: true,
            handler(val) {
                if (!val) {
                    this.treeRootList = []
                } else if (val === true) {
                    const orgName = this.loginUser.orgName
                    this.treeRootList = [
                        {
                            id: '0',
                            name: orgName,
                            open: true,
                            title: orgName
                        }
                    ]
                } else {
                    this.treeRootList = val
                }
            }
        },
        activeTreeNode: {
            handler(val) {
                console.log('activeTreeNode', val)
                if (!val) {
                    this.activeNode = null
                    return
                }
                if (!this.activeNode) {
                    this.activeNode = val
                    return
                }
                if (val.id !== this.activeNode.id) {
                    this.activeNode = val
                }
            }
        },
        activeNode: {
            handler(val) {
                this.setTreeSelect()
            }
        }
    },
    created() {
        if (this.$route.meta.params) this.productCode = this.$route.meta.params.split('=')[1]
        this.getTreeData()
        this.$bus.on('refreshTreeData', this.getTreeData)
    },
    beforeDestroy() {
        this.$bus.off('refreshTreeData', this.getTreeData)
    },
    mounted() {},
    methods: {
        onBasicFormSubmited: function ($scope, vo) {
            console.log('itemType form submited22222')
        },
        formSubmit() {
            if (this.rowVO.name == '' || this.rowVO.name == null) {
                this.$message({
                    message: '请输入证件类型！',
                    type: 'warning'
                })
                return
            }
            if (this.rowVO.status == '' || this.rowVO.status == null) {
                this.$message({
                    message: '状态不能为空！',
                    type: 'warning'
                })
                return
            }
            if (this.rowType == 'add') {
                this.$http({
                    url: 'zzgl/itemType/insert',
                    method: 'post',
                    data: this.rowVO
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        })
                        this.dialogVisible = false

                        this.getTreeData()
                    }
                })
            } else {
                this.$http({
                    url: 'zzgl/itemType/update',
                    method: 'put',
                    data: this.rowVO
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        })
                        this.dialogVisible = false
                        this.rowVO = {}
                        this.getTreeData()
                    }
                })
            }
        },
        cellClick(row) {
            this.$vnode.context.cellClick(row)
            // console.log(row)
            // if (!row.id) {
            //     return
            // }
            // window.open(
            //     `/#/commonHeader?workform=@/wapp/fzgl/flzx/zxwd/components/viewContent&wfEngineUrl=zsgl/knowledge&busiDataId=${row.id}&viewContent=1` + '&type=zsgl' + `&logoTitle=法治咨询/咨询问答/${row.subject}`
            // )
        },
        openTreeMenu(event, data, node, target) {
            console.log(event, data, node, target)
            this.showTreeMenu = true // 显示菜单
            this.currentData = data // 存储数据
            document.querySelector('.treeMenu').setAttribute('style', `top:${event.clientY + 10}px;left:${event.clientX + 10}px;`)
            // document.addEventListener('click', this.closeTreeMenu)
            // document.addEventListener('contextmenu', this.closeTreeMenu)
        },
        handleNodeClick(data) {
            console.log('data', data)
            this.currentDataid = data.id
            this.$emit('activeTreeNodeChange', data)
            this.$emit('active-tree-node-change', data)
            this.$bus.emit('refreshListData')
            this.showTreeMenu = false
        },
        // 获取树结构数据
        getTreeData() {
            let url = this.querydataUrl || this.moduleInfo.querydataUrl
            if (!url) {
                const defaultUrl = this.moduleInfo.listDataUrl
                const reg = /^(\/?\w+\/\w+\/)(.*)/
                url = defaultUrl.replace(reg, '$1querydata')
            }
            this.$http({
                url,
                method: 'POST',
                params: {
                    pageNum: 1,
                    orderBy: 'orderNo asc',
                    pageSize: 65000
                }
            }).then((res) => {
                if (res.code !== 'success') {
                    return this.$alert(res.message, '操作提示', {
                        type: 'error'
                    })
                }
                const listdata = [].concat(this.treeRootList, res.body.pageInfo.list)
                const obj = { id: 'sys', parentId: '0', name: '全部', categoryName: '全部', open: true, title: '全部' }
                listdata.unshift(obj)
                this.treeData = this.treeDataAdapter(listdata)
                if (this.treeData[0].children) {
                    this.defaultExpandedKeys.push(this.treeData[0].id)
                    this.currentData = this.treeData[0]
                    this.$nextTick(() => {
                        this.$refs['tree'].setCurrentKey(this.currentData.id)
                    })
                }
                if (!this.treeData.length) {
                    this.zTree = null
                    this.$emit('activeTreeNodeChange', null)
                    this.$emit('active-tree-node-change', null)
                }
            })
        },
        // 树结构转化
        treeDataAdapter(allTreeData) {
            const _this = this
            let treeData = JSON.parse(JSON.stringify(allTreeData))

            for (let i = 0; i < treeData.length; i++) {
                const node = treeData[i]

                node.checked = false
                if (node.type) node.type = node.type.replace(/\s*/g, '')

                // 选择机构目录、主机构
                node.pId = node.pId || node.parentID || node.parentId || node.treeId || -1
                node.nodeKeyId = node.id + node.pId
                node.name = node.nName || node.name

                node.canSelect = true

                if (node.orgFullId && !node.orgLevel && !node.olevel) {
                    node.orgLevel = node.orgFullId.split('-').length
                }
            }
            const nodesDict = {}
            treeData.forEach((v) => {
                if (v.parentId == null) {
                    v.parentId = 'sys'
                }
                v.pId = v.parentId || '0'
                v.title = v.name
                v.open = true
            })
            // 遍历数据，将每个节点添加到字典中
            treeData.forEach((item) => {
                nodesDict[item.id] = item
                const parent = nodesDict[item.parentId]
                if (parent) {
                    if (!parent.children) {
                        parent.children = []
                    }
                    parent.children.push(item)
                }
            })
            const tree = treeData.filter((node) => node.pId === '0')
            return tree
        },
        // 树结构加载完成
        onTreeCreated(zTree) {
            this.zTree = zTree
            if (this.$vnode.context.onTreeCreated) {
                this.$vnode.context.onTreeCreated(zTree)
                return
            }
            this.setTreeSelect()
        },
        // 选中树节点
        setTreeSelect() {
            const treenodes = this.zTree ? this.zTree.getNodes() : []
            console.log('123')
            if (treenodes.length <= 0) return
            if (this.activeNode === null) {
                this.onTreeNodeClick('', treenodes[0].id, treenodes[0]) // 选中第一节点
            } else if (this.treeData.some((v) => v.id === this.activeNode.id)) {
                this.zTree.selectNode(this.activeNode) // 选中当前节点
            } else {
                this.onTreeNodeClick('', treenodes[0].id, treenodes[0]) // 选中第一节点
            }
        },
        // 树结构点击事件
        onTreeNodeClick(evt, treeId, treeNode) {
            // this.dataTableShow = false
            this.activeNode = treeNode || null
            console.log('this.activeNode', this.activeNode)
            this.$emit('activeTreeNodeChange', this.activeNode)
            this.$emit('active-tree-node-change', this.activeNode)
            // this.$nextTick(() => {
            //     this.dataTableShow = true
            // })
        },
        // 新增树
        addMenu(tree) {
            // console.log('addMenu', this.$vnode.context)
            // this.$vnode.context.addMenuTreeType(this)
            this.showTreeMenu = false
            this.dialogVisible = true
            this.rowVO = {
                name: '',
                orderNo: '',
                status: ''
            }
            console.log('tree', this.rowVO)

            this.$http({
                method: 'post',
                url: 'zzgl/itemType/addNew'
            }).then((res) => {
                this.rowVO = res.body.vo
                this.rowType = 'add'
            })
        },
        // 编辑树
        editMenu(treeNode) {
            console.log('treeNode', treeNode)
            // this.$vnode.context.editMenuTreeType(this, treeNode)
            this.showTreeMenu = false
            this.dialogVisible = true
            this.$http({
                method: 'get',
                url: 'zzgl/itemType/getById?id=' + treeNode.id
            }).then((res) => {
                this.rowType = 'edit'
                this.rowVO = res.body.vo
            })

            // if (this.$vnode.context.editMenu) {
            //     this.$vnode.context.editMenu(treeId, treeNode)
            //     return
            // }
            // this.$bus.emit('openBusiform', this.moduleInfo, treeNode, 1)
        },
        // 删除树
        delMenu(treeNode) {
            // this.$refs.dataTable.deleteIds(treeNode, null, null, 1)
            this.showTreeMenu = false
            this.$confirm('您是否确定删除该分组吗？', '确认操作', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            })
                .then(() => {
                    this.$http({
                        method: 'delete',
                        url: '/zzgl/itemType/delete',
                        params: {
                            ids: treeNode.id
                        }
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.$message.success(res.message)
                            this.getTreeData()
                        } else {
                            this.$message.warning(res.message)
                        }
                    })
                })
                .catch(() => {
                    // do nothing
                })
        },
        selectedRowsChange(row) {
            this.array = []
            row.forEach((item) => {
                this.array.push(item.id)
            })
        },
        getArray() {
            return this.array
        }
    }
}
</script>

<style scoped lang="scss">
.date_table_tree {
    display: flex;
    .date_table_tree_border {
        width: 240px;
        min-width: 240px;
        border: 1px solid #d8dce5;
        margin-right: 10px;
        height: calc(100vh - 60px - 50px - 20px - 50px - 20px);
        display: flex;
        flex-direction: column;
    }
    .date_table_tree_btn {
        display: flex;
        justify-content: center;
        margin-top: 50px;
    }
}
.panel-right {
    position: relative;
    height: calc(100vh - 50px - 50px - 60px - 22px - 20px);
    .el-button-group {
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 99;
    }
}
/deep/ .el-tree-node__content {
    height: 30px;
    line-height: 20px;
    border-bottom: none;
    span {
        span {
            font-size: 14px !important;
        }
    }
}
.input-with-select {
    width: 400px;
}
/deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: var(--bgColor) !important;
    color: var(--textColor) !important;
}
.el-tree {
    /* 设置滚动条thumb（滑块）的颜色 */
    &::-webkit-scrollbar-thumb {
        background-color: #d2d4da;
        border-radius: 6px;
    }

    /* 增加滚动条的宽度，高度 */
    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    /* 设置滚动条hover时thumb的颜色 */
    &::-webkit-scrollbar-thumb:hover {
        background-color: #d2d4da;
        cursor: pointer;
    }
}
.empty-tree {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #909399;
    font-size: 14px;
}
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
.treeMenu {
    font-size: 14px;
    position: fixed;
    padding: 2px 0px 5px;
    z-index: 99999;
    top: 50%;
    left: 50%;
    background-color: rgba(255, 255, 255, 0.9);
    overflow: hidden;
    border-radius: 5px;
    border: 1px solid #e6ebf5;
    div {
        padding: 8px 10px;
        box-sizing: border-box;
        text-align: left;
    }
    div:hover {
        background-color: #eee;
        cursor: pointer;
    }
}
</style>
